import { h } from 'preact';
import util from 'preact-util';
import { Text } from 'preact-i18n';

// «Til gode» badge for the visitor card. Renders nothing unless balance > 0.
function CustomerCreditBadge({ balance }) {
    if (!(balance > 0)) {
        return null;
    }
    const amount = util.format(balance, 2, ',', ' ');
    return (
        <span class='badge bg-success ms-2' style='font-size: 0.65em;'>
            <i class='fa-solid fa-piggy-bank me-1' />
            <Text id='reskonto.creditBadge' fields={{ amount }}>{`Credit NOK ${amount}`}</Text>
        </span>
    );
}

export default CustomerCreditBadge;
